import { BillPay } from "components/BillPay";
import { BillPayInvalid } from "components/BillPay/BillPayInvalid";
import { BillPayLoading } from "components/PageLoading/BillPayLoading";
import { Layout } from "antd";
import { PageHeader } from "components/PageHeader/PageHeader";
import { createFileRoute } from "@tanstack/react-router";
import { useProviderInfoByAccessToken } from "api/VynePaymentsExternal/clients/useProviderInfoByAccessToken";

export const Route = createFileRoute("/p/$providerToken")({
    component: BillPayRoute,
});

function BillPayRoute() {
    const { providerToken } = Route.useParams();
    const { data, isPending, isError } = useProviderInfoByAccessToken(providerToken);

    if (isError) {
        return <BillPayInvalid />;
    }

    return (
        <Layout>
            <PageHeader isPending={isPending} name={data?.name} logoUrl={data?.logo} />
            {isPending ? <BillPayLoading /> : <BillPay providerAccessToken={providerToken} providerData={data} />}
        </Layout>
    );
}
